import { render } from "./StepUseDitto.vue?vue&type=template&id=1d5b9ea9&ts=true"
import script from "./StepUseDitto.vue?vue&type=script&lang=ts"
export * from "./StepUseDitto.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__